export enum CardProtectionRoutes {
    InsuranceDetail = "/mis-seguros/pga/proteccion-tarjeta/:productCode/detalle-poliza/:systemCode/:policyId",
    InsuranceCoverage = "/mis-seguros/pga/proteccion-tarjeta/:productCode/detalle-poliza/:systemCode/:policyId/cobertura/:coverageId",
    InsuranceExclusion = "/mis-seguros/pga/proteccion-tarjeta/:productCode/detalle-poliza/:systemCode/:policyId/exclusion/:exclusionId",
    InsurancePayments = "/v1/#/pga/proteccion-de-tarjeta/:productCode/mis-pagos/:systemCode/:policyId",

    UnderstandingInfo = "/mis-seguros/pga/proteccion-tarjeta/:productCode/detalle-poliza/:systemCode/:policyId/entendiendo-seguro",
    UsageInfo = "/mis-seguros/pga/proteccion-tarjeta/:productCode/detalle-poliza/:systemCode/:policyId/uso-seguro",
    InquiriesInfo = "/mis-seguros/pga/proteccion-tarjeta/:productCode/detalle-poliza/:systemCode/:policyId/consulta-reclamo",
}
